import { forwardRef } from "@heroui/react"
import { useState } from "react"
import { mergeProps, PressEvent, useHover, useLongPress, usePress } from "react-aria"

export type PanelProps = {
  onPress?: (ev?: PressEvent) => void
  onLongPress?: (ev?: PressEvent) => void
}
export const Panel = forwardRef<'div', PanelProps>(({
  onPress,
  onLongPress,
  as,
  children,
  ...props }, ref) => {

  const Component = as || 'div'
  const { pressProps, isPressed } = usePress({

    onPressStart: (e) => {
      e.continuePropagation()
    },
    onPressEnd: (e) => {
      e.continuePropagation()

    },
    onPress(e) {
      if (onPress && onPress(e)) {
        return
      }
      
      e.continuePropagation()

    },
  })

  let { longPressProps } = useLongPress({
    onLongPress: (e: any) => {
      onLongPress && onLongPress(e)
    },
  });

  const [hover, setHover] = useState(false)
  const { hoverProps } = useHover({
    onHoverStart: (e) => setHover(true),
    onHoverEnd: (e) => setHover(false),
  })

  return <Component
    ref={ref}
    data-pressed={isPressed}
    data-hover={hover}
    {...mergeProps(hoverProps, pressProps, onLongPress ? longPressProps : null)}
    {...props}
  >
    {children}
  </Component>
})